/* Lareforme 2026-07-20 v2: remove the Loox "Review summary (Summarized by AI)" card.
   Handles inline DOM and open shadow-DOM rendering; an iframe-based widget can only
   be changed from the Loox admin (widget editor).
   Rollback: remove this file and its script tag in snippets/lrf-global-css.liquid */
(function () {
  'use strict';

  var HIDE_CSS = '[class*="summary" i],[id*="summary" i]{display:none !important;}';

  function looxContainers() {
    var list = Array.prototype.slice.call(
      document.querySelectorAll('#looxReviews, .loox-reviews-default, [id^="looxReviews"]')
    );
    var all = document.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].tagName && all[i].tagName.indexOf('LOOX') === 0) list.push(all[i]);
    }
    return list;
  }

  function forEachRoot(node, fn) {
    fn(node);
    if (!node.querySelectorAll) return;
    var all = node.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) forEachRoot(all[i].shadowRoot, fn);
    }
  }

  function injectStyle(root) {
    try {
      if (root.nodeType === 11 && !root.__lrfStyled) { // shadow root
        var st = document.createElement('style');
        st.textContent = HIDE_CSS;
        root.appendChild(st);
        root.__lrfStyled = true;
      }
    } catch (e) {}
  }

  function hideSummaryIn(root, container) {
    if (!root.querySelectorAll) return;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length !== 0) continue;
      var txt = el.textContent || '';
      if (!/summarized by ai/i.test(txt)) continue;

      var card = el.closest && el.closest('[class*="summary" i]');
      if (!card || card === container) {
        card = el;
        var baseLen = txt.length;
        var hops = 0;
        while (
          card.parentElement &&
          card.parentElement !== container &&
          hops < 8 &&
          (card.parentElement.textContent || '').length <= baseLen + 400
        ) {
          card = card.parentElement;
          hops++;
        }
      }
      if (card && card !== container) {
        card.style.setProperty('display', 'none', 'important');
      }
    }
  }

  function run() {
    looxContainers().forEach(function (box) {
      forEachRoot(box, function (root) {
        injectStyle(root);
        hideSummaryIn(root, box);
      });
      if (!box.__lrfSummaryObserver) {
        var mo = new MutationObserver(function () {
          forEachRoot(box, function (root) {
            injectStyle(root);
            hideSummaryIn(root, box);
          });
        });
        mo.observe(box, { childList: true, subtree: true });
        box.__lrfSummaryObserver = mo;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // The widget (and InstantClick page swaps) can arrive late — re-check a few times.
  var attempts = 0;
  var timer = setInterval(function () {
    attempts++;
    run();
    if (attempts > 25) clearInterval(timer);
  }, 1000);
})();

/* --- Lareforme 2026-07-21: Kaching bundle quantity fix for the LIVE knee product.
   The Kaching bundle widget posts quantity=1 to Turbo's ajax cart when a
   2-pack/3-pack is selected. theme.liquid contains the same fix hardcoded to the
   OLD (draft) product 8142479982701; this covers the live product 8158519984237.
   Rollback: remove this block. --- */
(function () {
  'use strict';

  var BUNDLE_PRODUCT_ID = '8158519984237';

  function bundleQty(form) {
    if (!form) return 1;
    var pid = (form.querySelector('[name="product-id"]') || {}).value || '';
    if (String(pid) !== BUNDLE_PRODUCT_ID) return 1;
    var selected = form.querySelector('.kaching-bundles__bar--selected');
    var text = selected
      ? (((selected.querySelector('.kaching-bundles__bar-title') || {}).textContent || selected.textContent || '')).toLowerCase()
      : '';
    if (text.indexOf('3 pack') !== -1) return 3;
    if (text.indexOf('2 pack') !== -1) return 2;
    return 1;
  }

  function payload(form, qty) {
    var params = new URLSearchParams(new FormData(form));
    params.delete('properties[__kaching_bundles]');
    params.set('quantity', String(qty));
    params.set('properties[_Bundle]', qty + ' pack');
    return params.toString();
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest(
      'form[action*="/cart/add"] .ajax-submit, form[action*="/cart/add"] .add_to_cart, form[action*="/cart/add"] [name="add"]'
    );
    if (!button) return;
    var form = button.closest('form');
    var qty = bundleQty(form);
    if (qty <= 1) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    button.setAttribute('disabled', 'disabled');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'application/json'
      },
      body: payload(form, qty)
    })
      .then(function (r) {
        if (!r.ok) throw r;
        window.location.href = '/cart';
      })
      .catch(function (e) {
        console.warn('LRF bundle fix failed, falling back to normal submit', e);
        form.submit();
      })
      .finally(function () {
        button.removeAttribute('disabled');
      });
  }, true);
})();
